<ng-template
  *ngIf="!params.node.group"
  [ngTemplateOutlet]="statusTmpl"
  [ngTemplateOutletContext]="{ $implicit: color }"
>
</ng-template>
<div *ngIf="params.node.group" class="lh-1">
  <ng-container *ngFor="let status of ['added', 'modified', 'deleted']; let last = last; trackBy: trackByValue">
    <div *ngIf="groupedChanges[status]" class="flex items-center" [class.mb-1]="!last">
      <span class="mr-1">{{ groupedChanges[status] }}x</span>
      <ng-template *ngTemplateOutlet="statusTmpl; context: { $implicit: status }"></ng-template>
    </div>
  </ng-container>
</div>

<ng-template #statusTmpl let-color>
  <div class="square {{ color }}" [ngSwitch]="color" [matTooltip]="color">
    <ng-container *ngSwitchCase="'added'">+</ng-container>
    <ng-container *ngSwitchCase="'modified'">*</ng-container>
    <ng-container *ngSwitchCase="'deleted'">-</ng-container>
    <ng-container *ngSwitchCase="'conflict'">
      <fa-icon class="fs-08 text-red-600" [icon]="['fal', 'exclamation-triangle']"></fa-icon>
    </ng-container>
  </div>
</ng-template>
